<template>
  <div id="app">
    <div class="collection-search">
      <div>
        <el-input
          v-model="searchVal.name"
          placeholder="姓名查询"
          @keyup.enter.native="query"
        ></el-input>
      </div>
      <div style="margin-left: 20px">
        <el-input
          v-model="searchVal.position_name"
          placeholder="职位名称查询"
          @keyup.enter.native="query"
        ></el-input>
      </div>
      <div class="en_btn">
        <div>
          <el-button
            type="primary"
            style="width: 200px;background: #0077ff;"
            @click.native.prevent="query"
            >查询</el-button
          >
          <el-button style="width: 120px" v-on:click="reset">重置</el-button>
        </div>
      </div>
    </div>
    <div class="collection-resume">
      <TablePage
        :isVisited="true"
        :data="deliverList"
        :columns="deliverColumns"
        :page="pages"
        @pageChange="deliverPageChange"
      ></TablePage>
    </div>
  </div>
</template>
<script>
import $api from "@/api/CollectionModule";
import TablePage from "@/components/TablePage";
export default {
  components: { TablePage },
  data() {
    return {
      searchVal: {
        name: "",
        position_name: ""
      },
      deliverColumns: [
        {
          prop: "avatar",
          width: 450,
          align: "center",
          render: (h, scope) => {
            return (
              <div style="display: flex;align-items: center;height: 85px;">
                <div style="position: relative;height: 85px;width: 64px;display: flex;flex-direction: column;justify-content: space-between;align-items: center;">
                  <img
                    style="display:flex;justify-content:center;align-items:center;width: 56px; height: 56px; border-radius: 28px;"
                    src={scope.row.cv_avatar}
                    onerror={scope.row.defaultimg}
                  />
                  <img style="position: absolute;right: 0;top: 0;" src={scope.row.sex} />
                  <span style="width: 64px;line-height: 19px;background: #0077FF;border-radius: 11px; font-size:12px; color:#fff;">{scope.row.wish_salary_name}</span>
                </div>
                <div style="margin-left:20px;height: 78px;display: flex;flex-direction: column;justify-content: space-between;align-items: start;">
                  <p>
                    <span style="font-size: 16px;font-family: MicrosoftYaHeiSemibold;color: #333333;">
                      {scope.row.cv_name}
                    </span>
                    <span style="font-size: 12px;font-family:MicrosoftYaHei;color: #333333;margin-left:20px;">
                      {scope.row.cv_tel}
                    </span>
                  </p>
                  <p style="font-size: 14px;font-family: MicrosoftYaHei;color: #333333;text-align: left;">
                    {scope.row.wish_position_name}
                    <span style="margin-left:30px;">
                      {scope.row.cv_job_status}
                    </span>
                  </p>
                  <p style="font-size: 12px;font-family: MicrosoftYaHei;color: #666666;text-align: left;">
                    {scope.row.cv_school}
                    <span style="margin-left:5px;">{scope.row.cv_major}</span>
                  </p>
                </div>
              </div>
            );
          }
        },
        {
          prop: "name",
          width: 450,
          align: "center",
          render: (h, scope) => {
            return (
              <div style="display: flex;flex-direction: column;align-items: flex-start;height:64px;justify-content: flex-end;font-size: 12px;font-family:MicrosoftYaHei;color: #666666;">
                <p style="text-align: left;">
                  {scope.row.project.start_time} - {scope.row.project.end_time}
                </p>
                <p style="text-align: left;">{scope.row.project.company}</p>
              </div>
            );
          }
        },

        {
          prop: "id",
          render: (h, scope) => {
            return h(
              "div",
              {
                attrs: {
                  style:
                    "display: flex;flex-direction: column;align-items: flex-end;height: 90px;justify-content: space-between;padding: 12px 0;"
                }
              },
              [
                h(
                  "a",
                  {
                    attrs: {
                      style:
                        "font-size: 12px;font-family: MicrosoftYaHei;color: #DE5F5F;background: none;cursor: pointer;"
                    },
                    on: {
                      click: () => {
                        this.cancelFavorites(scope.row.collection_id);
                      }
                    }
                  },
                  ["取消收藏"]
                ),

                h(
                  "a",
                  {
                    attrs: {
                      style:
                        "width: 93px;height: 30px;background: #FFFFFF;border-radius: 3px;border: 1px solid #0077FF;font-size: 12px;font-family: MicrosoftYaHei;color: #0077FF;display: flex;justify-content: center;align-items: center;cursor: pointer;"
                    },
                    on: {
                      click: () => {
                        this.goToResume(scope.row.cv_id, scope.row.position_id);
                      }
                    }
                  },
                  ["查看简历"]
                )
              ]
            );
          }
        }
      ],

      deliverList: [],
      page_cu: {
        current_page: 1,
        per_page: 5
      }
    };
  },
  computed: {
    pages() {
      return this.page_cu;
    }
  },
  created() {
    this.getCollectList();
  },
  //激活keep-alive触发
  activated() {
    //激活数据
  },
  deactivated() {
    //销毁
  },
  methods: {
    //重置
    reset() {
      let searchData = {
        name: "",
        position_name: ""
      };
      this.searchVal = { ...searchData };
      this.page_cu.current_page = 1;
      this.getCollectList();
    },
    //查询
    query() {
      this.page_cu.current_page = 1;
      this.getCollectList();
    },
    deliverPageChange(e) {
      this.page_cu.current_page = e;
      this.getCollectList();
    },
    goToResume(id, position_id) {
      this.$router.push({
        name: "ResumeDetailsForList",
        query: {
          id: id,
          position_id: position_id
        }
      });
    },
    cancelFavorites(id) {
      let params = {
        collection_id: id,
        is_collection: 0
      };
      $api
        .putCollect(params)
        .then(data => {
          if (this.deliverList.length === 1) {
            let { current_page } = this.page_cu;
            current_page = current_page - 1;
            if (current_page === 0) {
              current_page = 1;
            }
            this.page_cu["current_page"] = current_page;
          }
          this.getCollectList();
        })
        .catch(err => {
          console.log("getDeliverList", err);
        });
    },
    //获取收藏列表
    getCollectList() {
      let params = {
        page: this.page_cu.current_page,
        limit: this.page_cu.per_page
      };
      params = Object.assign(params, this.searchVal);
      console.log("params", params);
      $api
        .getCollectList(params)
        .then(data => {
          // console.log("getDeliverList" + data)
          let { list, current_page, last_page, per_page, total } = data.data;
          this.deliverList = list.map(v => {
            return {
              ...v,
              defaultimg: `this.src="${require("@/assets/imgs/hello.png")}"`,
              sex: `${
                v.cv_sex_name === "男"
                  ? require("@/assets/imgs/sex2.png")
                  : require("@/assets/imgs/sex1.png")
              }`
            };
          });
          this.page_cu = {
            current_page,
            last_page,
            per_page,
            total
          };
        })
        .catch(err => {
          console.log("getDeliverList", err);
        });
    }
  }
};
</script>
<style scoped>
#app {
  overflow: hidden;
}
/*  */
.collection-search {
  width: 1020px;
  background: #fff;
  border-radius: 5px;
  height: 80px;
  padding: 0 30px;
  display: flex;
  align-items: center;
}
.collection-search > div {
  width: 320px;
  height: 34px;
}
.collection-search div > div {
  display: flex;
  height: 34px;
  align-items: center;
}
.collection-search > div.date {
  width: 313px;
  display: flex;
  align-items: center;
}
.collection-search > div.date span {
  width: 18px;
  border-bottom: 1px solid #e7e7e7;
  height: 1px;
  line-height: 40px;
  margin: 0 11px;
}
.collection-search > div.select {
  width: 150px;
}
.collection-search div span {
  width: 18px;
  font-size: 14px;
  color: #666;
  margin-right: 6px;
}
.collection-search > div.en_btn {
  flex: 1;
  margin-left: 20px;
}
.collection-search > div.en_btn > div {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
/*  */
.collection-resume {
  width: 1080px;
  border-radius: 5px;
  background: #fff;
  margin-top: 17px;
  box-sizing: border-box;
  padding: 20px 30px;
}

.collection-resume .resume-pane {
  position: relative;
  width: 100%;
  box-sizing: border-box;
}
</style>
<style>
.collection-resume .el-tabs__item {
  height: auto;
  color: #888;
  font-size: 16px;
  padding: 20px 15px;
  line-height: normal;
}
.recollection-resumesume .el-tabs__active-bar {
  height: 4px;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/collection/list.vue